import { Component, inject, model } from '@angular/core';
import { RolesService } from '../services/roles.service';
import { ProfileService } from '../../profile/services/profile.service';
import { ActivatedRoute } from '@angular/router';
import { RoleModel } from '../../shared/models/role.model';
import { RoleFormComponent } from "../role-form/role-form.component";
import { CardModule } from 'primeng/card';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-role-delete',
  standalone: true,
  imports: [
    RoleFormComponent,
    CardModule,
  ],
  templateUrl: './role-delete.component.html',
  styleUrl: './role-delete.component.css'
})
export class RoleDeleteComponent {
  service = inject(RolesService)
  profile = inject(ProfileService).profile
  access = inject(AccessService).access
  route = inject(ActivatedRoute)

  id!: string | null;

  value = model<RoleModel | undefined>(undefined)
  error = model<any>(undefined)

  ngOnInit(): void {
    this.service.title.update((value) => 'Rol Eliminado')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getValue(params.get('id'));
    });
  }

  getValue(id: string | null) {
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.valueService.valueDetailed(id);
      this.service.delete(id).subscribe(res => {
        console.log('Respuesta: ', res);
        this.value.update(value => (value = res as RoleModel));
      }, error => {
        console.log('Error deleting Image: ', error);
        this.error.update(value => (value = error));
      });
    }
  }
}
